import React, { FC, useContext } from 'react';
import AuthPrompt from 'components/Ideas/AuthPrompt';
import CloseIcon from 'components/core/CloseIcon';
import { ProjectContext } from 'components/Ideas/index';
import { Modal } from 'antd';

type AuthModalProps = {
  visible: boolean;
  onClose: (arg0: boolean) => void;
}

const AuthModal: FC<AuthModalProps> = ({ visible, onClose }) => {
  const context = useContext(ProjectContext);

  return (
    (<Modal
      className="idea-auth-modal"
      centered
      open={visible}
      onCancel={() => onClose(false)}
      footer={null}
      zIndex={1200}
      bodyStyle={{ backgroundColor: context.primaryColor, padding: '3rem' }}
      getContainer={document.getElementById('ideas-container-component')}
      closeIcon={<CloseIcon color={context.offWhiteColor} hoverColor={context.whiteColor} />}
    >
      <AuthPrompt trigger="vote" />
    </Modal>)
  );
};

export default AuthModal;
